import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const AgenttransactionAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		agentcode: yup.string().nullable().label($t('agentcode')),
		transactiondate: yup.string().nullable().label($t('transactiondate')),
		debit: yup.string().required().label($t('debit')),
		credit: yup.string().required().label($t('credit')),
		narration: yup.string().nullable().label($t('narration')),
		ac_code: yup.string().nullable().label($t('acCode')),
		tds: yup.string().required().label($t('tds')),
		spot: yup.string().nullable().label($t('spot')),
		dateadded: yup.string().nullable().label($t('dateadded')),
		addedbyfk: yup.string().nullable().label($t('addedbyfk')),
		datemodified: yup.string().nullable().label($t('datemodified')),
		lastuserfk: yup.string().nullable().label($t('lastuserfk'))
	});
	
	//form default values
	const formDefaultValues = {
		agentcode: '', 
		transactiondate: new Date(), 
		debit: '', 
		credit: '', 
		narration: '', 
		ac_code: '', 
		tds: "((0))", 
		spot: '', 
		dateadded: new Date(), 
		addedbyfk: '', 
		datemodified: new Date(), 
		lastuserfk: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/agenttransaction`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="AgenttransactionAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewAgenttransaction')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('agentcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/agentcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="agentcode"     optionLabel="label" optionValue="value" value={formik.values.agentcode} onChange={formik.handleChange} options={response} label={$t('agentcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.agentcode)}   />
                                                    <ErrorMessage name="agentcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('transactiondate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="transactiondate" value={formik.values.transactiondate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.transactiondate)}        />
                                                <ErrorMessage name="transactiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('debit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="debit"  onChange={formik.handleChange}  value={formik.values.debit}   label={$t('debit')} type="text" placeholder={$t('enterDebit')}        className={inputClassName(formik?.errors?.debit)} />
                                                <ErrorMessage name="debit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('credit')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="credit"  onChange={formik.handleChange}  value={formik.values.credit}   label={$t('credit')} type="text" placeholder={$t('enterCredit')}        className={inputClassName(formik?.errors?.credit)} />
                                                <ErrorMessage name="credit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('narration')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="narration"  onChange={formik.handleChange}  value={formik.values.narration}   label={$t('narration')} type="text" placeholder={$t('enterNarration')}        className={inputClassName(formik?.errors?.narration)} />
                                                <ErrorMessage name="narration" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acCode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/ac_code_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="ac_code"     optionLabel="label" optionValue="value" value={formik.values.ac_code} onChange={formik.handleChange} options={response} label={$t('acCode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.ac_code)}   />
                                                    <ErrorMessage name="ac_code" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('tds')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="tds"  onChange={formik.handleChange}  value={formik.values.tds}   label={$t('tds')} type="text" placeholder={$t('enterTds')}        className={inputClassName(formik?.errors?.tds)} />
                                                <ErrorMessage name="tds" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('spot')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="spot"  onChange={formik.handleChange}  value={formik.values.spot}   label={$t('spot')} type="text" placeholder={$t('enterSpot')}        className={inputClassName(formik?.errors?.spot)} />
                                                <ErrorMessage name="spot" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dateadded')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dateadded" value={formik.values.dateadded} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.dateadded)}        />
                                                <ErrorMessage name="dateadded" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addedbyfk')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addedbyfk"  onChange={formik.handleChange}  value={formik.values.addedbyfk}   label={$t('addedbyfk')} type="text" placeholder={$t('enterAddedbyfk')}        className={inputClassName(formik?.errors?.addedbyfk)} />
                                                <ErrorMessage name="addedbyfk" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('datemodified')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="datemodified" value={formik.values.datemodified} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.datemodified)}        />
                                                <ErrorMessage name="datemodified" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastuserfk')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastuserfk"  onChange={formik.handleChange}  value={formik.values.lastuserfk}   label={$t('lastuserfk')} type="text" placeholder={$t('enterLastuserfk')}        className={inputClassName(formik?.errors?.lastuserfk)} />
                                                <ErrorMessage name="lastuserfk" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
AgenttransactionAddPage.defaultProps = {
	primaryKey: 'transactionid',
	pageName: 'agenttransaction',
	apiPath: 'agenttransaction/add',
	routeName: 'agenttransactionadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default AgenttransactionAddPage;
